import { render, staticRenderFns } from "./name-block.vue?vue&type=template&id=181a127b&"
import script from "./name-block.vue?vue&type=script&lang=js&"
export * from "./name-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports